// Histogram (§11.9): R, G, B and luma, 256 bins, from an 8-bit RGBA readback.
export type Histogram = { r: Uint32Array; g: Uint32Array; b: Uint32Array; l: Uint32Array; count: number };

export function computeHistogram(rgba: Uint8Array | Uint8ClampedArray): Histogram {
  const h: Histogram = {
    r: new Uint32Array(256),
    g: new Uint32Array(256),
    b: new Uint32Array(256),
    l: new Uint32Array(256),
    count: 0,
  };
  for (let i = 0; i < rgba.length; i += 4) {
    if (rgba[i + 3] === 0) continue; // transparent pixels are not part of the image
    const r = rgba[i]!,
      g = rgba[i + 1]!,
      b = rgba[i + 2]!;
    h.r[r]!++;
    h.g[g]!++;
    h.b[b]!++;
    // Luma on encoded values with P3 weights: a display histogram, not a measurement.
    h.l[Math.min(255, Math.round(0.2289746 * r + 0.6917385 * g + 0.0792869 * b))]!++;
    h.count++;
  }
  return h;
}
